import { TableFooter } from "@mui/material"
import { GTableRow } from "./GTableBody"
import { IGTableProps } from "./GTableConsts"

export default function GTableFooter<T>(props:IGTableProps<T>){
    let rows : JSX.Element[] = props.footers!.map((row:T,i) => {
        const key = (props.rowKey ? props.rowKey(row) : i) || i
        return <GTableRow {...props} row={row} key={key}/>
    })
    return <TableFooter>{rows}</TableFooter>
}